var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-base-modal',{attrs:{"loading":_vm.loading,"title":"Criar agrupamento"},on:{"save":function($event){return _vm.save()}}},[_c('produto-group-content',{attrs:{"payload":_vm.payload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }